import { render, staticRenderFns } from "./video_dialog.vue?vue&type=template&id=05dc8f54"
import script from "./video_dialog.vue?vue&type=script&lang=js"
export * from "./video_dialog.vue?vue&type=script&lang=js"
import style0 from "./video_dialog.vue?vue&type=style&index=0&id=05dc8f54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports